export default "__VITE_ASSET__uUNKNGWF__";